import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "./query";

export const portalApi = createApi({
  reducerPath: "portalApi",
  baseQuery: apiBaseQuery,
  endpoints: () => ({})
});
